"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiImpacteesPar = void 0;
exports.ESubScpiImpacteesPar = {
    evolutionLoyer: "evolutionLoyer",
    evolutionMarcheImmo: "evolutionMarcheImmo",
    desDeux: "desDeux",
};
